export const SNOWPACK_PUBLIC_BUILD = "538a85c";
export const SNOWPACK_PUBLIC_SENTRY_DSN = "https://3668b4b6e6274a00a33c27a37f22dbf2@o18925.ingest.sentry.io/5618528";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;